"use client";

import {
  List,
  ListItem,
  ListItemContent,
  ListItemIcon,
  ListItemText,
  RadioGroupIndicator,
  RadioGroupItem,
  RadioGroupRoot,
} from "@dafiti/closet-ui";

type SortOption = {
  label: string;
  value: string;
};

interface SortOptionListProps {
  options: SortOption[];
  currentValue: string;
  onSelect: (value: string) => void;
  onConfirmSelect?: (value: string) => void;
}

export function SortOptionList({
  options,
  currentValue,
  onSelect,
  onConfirmSelect,
}: SortOptionListProps) {
  return (
    <RadioGroupRoot
      value={currentValue}
      onValueChange={onSelect}
      data-testid="sort-option-list"
    >
      <List as="div" className="divide-y-0">
        {options.map((option) => (
          <ListItem
            key={option.value}
            as="label"
            className="w-full cursor-pointer py-nano"
            data-testid={`sort-option-item-${option.value}`}
            onClick={() => onConfirmSelect?.(option.value)}
          >
            <ListItemIcon className="w-max">
              <RadioGroupItem
                value={option.value}
                aria-label={option.label}
                data-testid={`sort-option-radio-${option.value}`}
              >
                <RadioGroupIndicator />
              </RadioGroupItem>
            </ListItemIcon>

            <ListItemContent className="flex-row items-center">
              <ListItemText className="text-body-2! font-normal">
                {option.label}
              </ListItemText>
            </ListItemContent>
          </ListItem>
        ))}
      </List>
    </RadioGroupRoot>
  );
}
